module.exports = __webpack_public_path__ + "static/media/bistrologo.9007e0d8.png";